import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Divider from '@mui/material/Divider';
import {FormattedMessage} from "react-intl";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import EditIcon from '@mui/icons-material/Edit';
import useBatchActionLauncher from "domain/components/merchandising/batchActions/useBatchActionLauncher";
import {MENU_KEY_TO_API_TYPE} from "domain/components/merchandising/batchActions/batchActionTypes";
import LargeBatchWarning from "domain/components/merchandising/batchActions/LargeBatchWarning";

export default function ActivateOfferActionModal(props) {
    const {open, setOpen, setSelectAction, selectedProducts, selectAll, totalItems} = props;
    const batchSize = selectAll ? totalItems : selectedProducts.length;
    const launchBatchAction = useBatchActionLauncher(props.onActionLaunched);

    const handleAction = () => {
        handleClose();

        let body = props.buildBody();
        if (selectAll) {
            body = {
                ...body,
                batchAction: MENU_KEY_TO_API_TYPE.activate
            };
        } else {
            body = {
                batchAction: MENU_KEY_TO_API_TYPE.activate,
                ids: selectedProducts
            };
        }

        launchBatchAction(body);
    };

    const handleClose = () => {
        setOpen(false);
        setSelectAction('');
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle
                id="alert-dialog-title"
                sx={{
                    marginX: 'auto'
                }}
            >
                <FormattedMessage id={"merchandising.batch_action.activate.modal.title"}/>
            </DialogTitle>
            <Divider />
            <DialogContent>
                <DialogContentText
                    id="alert-dialog-description"
                    sx={{
                        textAlign: 'center'
                    }}
                >
                    <FormattedMessage id={"merchandising.batch_action.activate.modal.body"}/>
                </DialogContentText>
                <LargeBatchWarning count={batchSize}/>
            </DialogContent>
            <DialogActions sx={{ padding: '15px'}}>
                <Button
                    onClick={handleClose}
                    startIcon={<ArrowBackIosIcon />}
                >
                    <FormattedMessage id={"merchandising.batch_action.modal.cancel"}/>
                </Button>
                <Button
                    onClick={handleAction}
                    variant="contained"
                    autoFocus
                    startIcon={<EditIcon/>}
                    sx={{
                        borderRadius: 28
                    }}
                >
                    <FormattedMessage id={"merchandising.batch_action.activate.modal.save"}/>
                </Button>
            </DialogActions>
        </Dialog>
    );
}
